export const moreNews = [
  {
    Nyhet: {
      createDate: "2023-12-14T16:04:56",
      title: "Anmälan till ledarskapsutveckling för chefer är öppen",
      bodyText: {
        content:
          '<p>Arbetar du som chef och vill utveckla och stärka ditt ledarskap? Då är det här utbildningen för dig. Under tio dagar får du verktyg för hur du genom ditt ledarskap kan skapa engagemang hos dina medarbetare och hur du som chef i staten kan bidra till att göra staten till en bra arbetsgivare.</p>\r\n<p>Programmet startar i april och pågår till november. Utbildningen vänder sig till chefer som vill utveckla och stärka sitt ledarskap.</p>\r\n<p>Är du intresserad av att delta skicka en intresseanmälan till myndighetens representant i Rörlighet i statens programgrupp. <a href="https://rorlighetistaten.se/deltagande-myndigheter">Deltagande myndigheter</a></p>\r\n<p>Vid frågor rörande utbildningen kontakta Carola Olofsson, <a>fornamn.efternamn@naturvardsverket.se</a></p>\r\n<p>Läs mer om utbildningen här:</p>\r\n<p><a href="https://rorlighetistaten.se/program-foer-din-utveckling/ledarskapsutveckling-foer-chefer">Ledarskapsutveckling för chefer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-08T08:04:56",
      title:
        "Tandvårds- och läkemedelsförmånsverket söker en projektledare för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att arbeta som projektledare för IT-upphandling på Tandvårds- och läkemedelsförmånsverket? De söker nu en projektledare för inlån och sex månader från tillträde.</p><p>Läs mer</p><p><a href="https://rorlighetistaten.se/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-08T08:20:44",
      title: "Post- och telestyrelsen söker en jurist för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att arbeta som jurist på Post- och telestyrelsen? Post och telestyrelsen söker nu en jurist för inlån med start efter nyår utifrån överenskommelse och sex månader från tillträde.</p><p>Läs mer</p><p><a href="https://rorlighetistaten.se/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-12T08:20:44",
      title:
        "Vinnova söker en handläggare för industriell utveckling för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Vinnova? De söker just nu en handläggare för industriell utveckling för inlån under sex månader.</p><p><a href="https://rorlighetistaten.se/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-15T08:20:44",
      title: "Ekonomistyrningsverket blir RIS tjugonde medlem! ",
      bodyText: {
        content:
          '<p><strong>Nu har RIS fått ytterligare en medlem, Ekonomistyrningsverket! Ekonomistyrningsverket, som brukar förkortas ESV, är en expertmyndighet som utvecklar den ekonomiska styrningen för regeringen, Regeringskansliet och andra statliga myndigheter samt gör analyser och prognoser av statens ekonomi. Elina Bentham är HR-specialist på ESV och ser väldigt positivt på RIS-samarbetet och hur det möjliggör fler utvecklingsmöjligheter när det kommer till samverkan och utbyte av erfarenheter.</strong></p><p>-	Vi lever i en föränderlig tid och måste snabbt kunna anpassa oss till nya förutsättningar utifrån givna uppdrag. Att samverka och dela med oss av våra erfarenheter och kompetenser tror vi är en nyckel för att lyckas och utvecklas tillsammans. Därför ser vi framemot möjligheten att bredda detta inom ramen för RIS.</p><p>- Och eftersom att vi på ESV är vana att sedan tidigare verka inom nätverk och samarbeten så är det nu väldigt positivt att få möjligheten att på ett mer strukturerat sätt erbjuda våra medarbetare dessa utvecklingsmöjligheter, säger Elina.</p><p>Vad tycker du att vi som jobbar på myndigheter kan hjälpas åt med för att göra staten till Sveriges bästa arbetsplats?</p><p>-	Som myndigheter står vi ofta inför liknande utmaningar, att kunna hjälpas åt och dela med sig av kompetenser, erfarenheter och perspektiv är något som gör staten unikt och viktigt att värna.</p><p><img src="https://rorlighetistaten.se/media/1501/elina-bentham.jpg" alt="Bild på Elina Bentham"/></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-17T08:20:44",
      title: "Nätverk för statliga produktägare",
      bodyText: {
        content:
          "<p>Jobbar du som produktägare på någon av myndigheterna inom Rörlighet i staten och vill utbyta erfarenheter med andra? Vi startar ett nytt nätverk kring att bygga digitala produkter i en statlig kontext.</p><p>Så här beskriver kontaktpersonen för nätverket Andreas Duvhammar på Tillväxtverket tanken med nätverket.</p><p>Att bygga digitala produkter i en statlig kontext är speciellt jämfört med den privata sfären. Många av produktägares eller product managers klassiska kärnuppgifter blir mindre relevanta (eller till och med helt obsoleta) medan andra frågor blir desto viktigare.</p><p>Exempelvis får affärsmässiga frågor som marknadsanalys, produkt-marknads-matchning, intäkter och marknadsföring mindre relevans. Istället blir frågor som att leverera under en fastställd budget, efterleva regelverk, göra det mesta av skattebetalarnas pengar och skapa maximal samhällsnytta viktiga. Vilka faktorer är viktiga för att lyckas bygga en värdefull digital produkt under de särskilda omständigheterna? Hur mäter vi om vi lyckats när vi pratar om samhällsnytta istället för intäkter?</p><p>Nästan alla resurser och utbildningar som handlar om produktägarskap utgår ifrån att man rör sig inom den privata sektorn. Jag ser därför en blind spot som ett nätverk inom Rörlighet i Staten skulle kunna fylla. Statliga produktägare skulle kunna utbyta erfarenheter, coacha och tipsa varandra. Vi utvecklar gemensamt hur vi vill jobba i nätverket och vilka frågor vi vill ta upp.</p><p>Är du intresserad av att delta i nätverket, kontakta Andreas Duvhammar Andreas.Duvhammar@tillvaxtverket.se</p>",
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-01-17T09:20:44",
      title: "Svenska ESF-rådet söker en HR-specialist för inlån",
      bodyText: {
        content:
          '<p>Vill  du prova på att jobba på Svenska ESF-rådet? De söker just nu en HR-specialist för inlån under fem månader.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-02-07T09:20:44",
      title: "Vinnova söker en kommunikatör för inlån",
      bodyText: {
        content:
          '<p>Vill du prova att jobba på Vinnova? De söker just nu en kommunikatör för inlån under sex månader.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-03-06T09:20:44",
      title: "Naturvårdsverket söker klimathandläggare för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Naturvårdsverket? De söker nu en handläggare för inlån till sista augusti.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-03-07T09:20:44",
      title: "Ekonomistyrningsverket söker en jurist för inlån",
      bodyText: {
        content:
          '<p>Vill du prova att jobba på Ekonomistyrningsverket? De söker just nu en jurist för inlån under sex månader.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-03-18T09:20:44",
      title: "Kännedomsundersökning om Rörlighet i staten",
      bodyText: {
        content:
          '<p>I dagarna får alla medarbetare i de 20 myndigheter som ingår i Rörlighet i staten en enkät med frågor om kännedomen och bilden av Rörlighet i staten.</p><p>Ditt bidrag är viktigt för att vi ska kunna forma och planera våra framtida insatser och kommunikationsstrategier på bästa sätt.</p><p>Har du frågor är du välkommen att höra av dig till <a href="christina.frimodig@naturvardsverket.se">christina.frimodig@naturvardsverket.se</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-03-26T09:20:44",
      title: "Formas söker IT-samordnare för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Formas? De söker just nu en IT-samordnare för inlån under sju månader.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-04-10T09:20:44",
      title: "Anmäl dig till kursen Leda utan att vara chef",
      bodyText: {
        content:
          '<p>Vill du stärka din förmåga att skapa engagemang hos dina arbetskamrater, att coacha och driva projekt framåt?</p><p>Utbildningen Leda utan att vara chef stärker din förmåga att möta och hantera de situationer vi kan ställas inför som ledare utan formellt personalansvar. Konkreta verktyg, insikter i ledarrollen och teoretisk kunskap som kan omsättas praktiskt i det dagliga ledarskapet ingår i Leda utan att vara chef. Under utbildningen jobbar vi också med vad det innebär att verka inom staten, vad är en god förvaltningskultur, vad innebär den statliga värdegrunden och hur kan jag utveckla min etiska kompass.</p><p>Deltagare brukar också uppskatta det nätverk av kollegor på andra myndigheter som deltar i utbildningen.</p><p><strong>Utbildningens upplägg</strong></p><p>Varje utbildning tar max 21 deltagare och pågår under fem heldagar och två halvdagar, varav en halvdag är med Statskontoret.</p><p><strong>Målgrupp</strong></p><p>Utbildningens målgrupp är medarbetare som är anställda på någon av myndigheterna inom Rörlighet i staten och som leder andra utan att ha formellt chefsansvar.</p><p><strong>Intresseanmälan</strong>/p><p>Är du intresserad av att delta, stäm av med din chef som i sin tur anmäler dig till myndighetens kontaktperson i Rörlighet i statens programgrupp.</p><p>Vid frågor kontakta Nina Hird, Forte. Nina.hird@forte.se</p><p>Läs mer om utbildningen och rörlighet i staten på: <a href="/program-foer-din-utveckling/leda-utan-att-vara-chef/">Leda utan att vara chef</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-04-16T09:20:44",
      title: "Vinnova söker registrator/administratör för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Vinnova? De söker just nu en registrator/administratör för inlån under sex månader. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-04-30T09:20:44",
      title: "Erfarenhetsutbyte om desinformation – Rörlighet i staten ",
      bodyText: {
        content:
          '<p>Vill du veta mer om desinformation, hur vi som myndigheter kan hantera desinformation och hur andra myndigheter jobbar? Välkommen till Rörlighet i statens digitala popup-samtal den 31 maj kl 9-11.  </p><p><a href="/inspirationsforelasningar-och-samtal/erfarenhetsutbyte-om-desinformation/">Mer info och anmälan</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-03T09:20:44",
      title: "Formas söker analytiker för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Formas under ett halvår. De söker just nu en analytiker för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-03T09:20:44",
      title: "Formas söker kommunikatör för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Formas under ett halvår. De söker just nu en kommunikatör för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-03T09:20:44",
      title:
        "Vill du delta i nätverk för utveckling av digitala verktyg inom staten?",
      bodyText: {
        content:
          '<p>Jobbar du som produktägare/systemägare på någon av myndigheterna inom Rörlighet i staten och vill utbyta erfarenheter med andra? Vi startar ett nytt nätverk kring att bygga digitala produkter i en statlig kontext.</p><p>Att bygga digitala produkter inom staten är speciellt jämfört med den privata sfären. Många av produktägares eller product managers klassiska kärnuppgifter blir mindre relevanta medan andra frågor blir desto viktigare.</p><p>Exempelvis får affärsmässiga frågor som marknadsanalys, produkt-marknads-matchning, intäkter och marknadsföring mindre relevans. Istället blir frågor som att leverera under en fastställd budget, efterleva regelverk, göra det mesta av skattebetalarnas pengar och skapa maximal samhällsnytta viktiga. Vilka faktorer är viktiga för att lyckas bygga en värdefull digital produkt under de särskilda omständigheterna? Hur mäter vi om vi lyckats när vi pratar om samhällsnytta istället för intäkter?</p><p>Nästan alla resurser och utbildningar som handlar om produktägarskap utgår ifrån att man rör sig inom den privata sektorn. Det finns därför en blind spot som ett nätverk inom Rörlighet i Staten skulle kunna fylla. Statliga produktägare skulle kunna utbyta erfarenheter, coacha och tipsa varandra. Vi utvecklar gemensamt hur vi vill jobba i nätverket och vilka frågor vi vill ta upp.</p><p>Är du intresserad av att delta i nätverket, kontakta Andreas Duvhammar, <a href="mailto:Andreas.Duvhammar@tillvaxtverket.se">Andreas.Duvhammar@tillvaxtverket.se</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-03T09:20:44",
      title: "Hög kännedom om Rörlighet i staten",
      bodyText: {
        content:
          '<p>Våren 2024 genomförde IVL Svenska Miljöinstitutet, på uppdrag av Naturvårdsverket och Rörlighet i staten (RIS), en enkätundersökning för att kartlägga medvetenheten och uppfattningen om RIS bland anställda vid de 20 myndigheter som deltar i samarbetet. - Syftet med undersökningen är att ge en grund för framtida utveckling och kommunikationsinsatser inom RIS verksamhet, säger Ingela Hiltula, som är ordförande för verksamheten.</p><p><a href="/hog-kannedom-om-rorlighet i staten/">Läs mer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-04T09:20:44",
      title: "Boka in höstens inspirationsföreläsningar med Rörlighet i staten",
      bodyText: {
        content:
          '<p><strong>I höst bjuder Rörlighet i staten in till tre digitala föreläsningar för att stärka kompetensen inom viktiga samhälls- och arbetslivsområden. Experter bjuder på insiktsfulla föreläsningar om digitalisering med AI, frågan om ålderism och ledarskap för en hållbar hybrid arbetsplats. Föreläsningarna är för dig som arbetar på en myndighet inom Rörlighet i staten.</strong></p><p>Boka gärna in tiderna i kalendern redan nu. Anmälan kommer ut efter sommaren.</p><p><a href="/inspirationsforelasningar-och-samtal/">Läs mer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-04T09:20:44",
      title: "Spelinspektionen söker ekonom för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Spelinspektionen? De söker just nu en ekonom för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-04T09:20:44",
      title: "Spelinspektionen söker informationssäkerhetssamordnare för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på att jobba på Spelinspektionen? De söker just nu en informationssäkerhetssamordnare för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-10T09:20:44",
      title: "Energimyndigheten söker handläggare för inlån",
      bodyText: {
        content:
          '<p>Vill du prova på nya arbetsuppgifter under en tid och förstärka teamet som vill förverkliga en satsning på bio-CCS i stor skala? Energimyndigheten söker just nu handläggare till satsningen för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-10T09:20:44",
      title: "Klimatpolitiska rådet söker utredare för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Klimatpolitiska rådet, som är kopplat till Formas. De söker just nu en utredare för inlån.  </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-06-25T09:20:44",
      title: "Formas söker digital verksamhetsutvecklare för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Formas. De söker just nu en digital verksamhetsutvecklare för inlån.  </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-07-01T09:20:44",
      title: "Post- och telestyrelsen söker produkttestare för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Post- och telestyrelsen. De söker just nu en produkttestare för inlån. </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-08-26T09:20:44",
      title: "Vinnova söker en handläggare för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Vinnova. De söker just nu en handläggare till ett regeringsuppdrag kring EU:s gröna giv.  </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-09-04T09:20:44",
      title:
        "Naturvårdsverket söker handläggare för klimatanpassning för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Naturvårdsverket. De söker just nu en handläggare för klimatanpassning för inlån.  </p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-09-09T09:21:44",
      title: "Nu kan du anmäla dig till höstens inspirationsföreläsningar",
      bodyText: {
        content:
          '<div><p><strong>Rörlighet i staten (RIS) bjuder in till en spännande serie inspirationsföreläsningar under hösten 2024. Föreläsningarna är öppna för alla medarbetare inom myndigheter som deltar i RIS, och syftar till att stärka kompetensen inom viktiga samhälls- och arbetslivsområden. Experter bjuder på insiktsfulla föreläsningar om digitalisering med AI, frågan om ålderism och ledarskap för en hållbar hybrid arbetsplats.</strong></p><p>Anmälan till föreläsningarna sker via den här länken <a href="https://registration.invajo.com/7cec8a80-58e1-47bc-92bd-8d747a630f27">”Anmälan till inspirationsföreläsningar”</a>. Du kan anmäla dig till en eller flera av de tre föreläsningarna. När du klickar på anmälningslänken registrerar du din e-postadress, anger vilken myndighet du jobbar på och väljer de föreläsningar du vill delta i. Det finns även en anmälningslänk tillgänglig när du väljer att läsa mer om varje föreläsning nedan. Sista anmälningstid är senast kl. 17:00 dagen innan respektive föreläsning.</p><p><strong>Digitalisering med AI i offentlig förvaltning</strong><br />Den 20 september kl. 09:00 – 10:00 kommer Mats Snäll från Myndigheten för digital förvaltning (DIGG) att tala om hur AI kan användas för att effektivisera och förbättra kvaliteten på offentliga tjänster. Föreläsningen kommer att ge en förståelse för vad AI innebär för offentlig förvaltnings digitalisering och vilka möjligheter som finns med exempelvis generativ AI.<br /><br />Datum: 20 september<br /><br />Tid: 09:00 – 10:00<br /><br />Föreläsare: Mats Snäll från Myndigheten för digital förvaltning (DIGG)<br /><br />Sista anmälningstid: 19 september kl 17.00<br /><br /><a href="/inspirationsforelasningar-och-samtal/inspirationsforelasning1">Läs mer och anmäl dig till föreläsningen.</a></p><p><strong>Den nya åldern eller Ålderism?</strong><br />Den 18 oktober kl. 09:00-10:00 adresserar John Mellkvist från Kreab det aktuella ämnet ålderism i arbetslivet. Föreläsningen syftar till att öka medvetenheten om åldersdiskriminering och främja en inkluderande arbetsmiljö där alla åldersgrupper värderas lika.<br /><br />Datum: 18 oktober<br /><br />Tid: 09:00 – 10:00<br /><br />Föreläsare: John Mellkvist från Kreab<br /><br />Sista anmälningstid: 17 oktober kl 17.00<br /><br /><a href="/inspirationsforelasningar-och-samtal/inspirationsforelasning2">Läs mer och anmäl dig till föreläsningen.</a></p><p><strong>Strategier för självledarskap och kollektivt ledarskap</strong><br />Den 22 november kl. 09:00-10:00 kommer Nina Bozic, senior forskare på RISE, att utforska strategier för både självledarskap och kollektivt ledarskap, med fokus på att skapa hållbara hybrida arbetsplatser. Föreläsningen kommer att ge värdefulla verktyg för att navigera och leda i en flexibel arbetsmiljö.<br /><br />Datum: 22 november<br /><br />Tid: 09:00 – 10:00<br /><br />Föreläsare: Nina Bozic<br /><br />Sista anmälningstid: 21 november kl 17.00<br /><br /><a href="/inspirationsforelasningar-och-samtal/inspirationsforelasning3">Läs mer och anmäl dig till föreläsningen.</a></p></div>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-09-13T09:21:44",
      title:
        "Erfarenhetsutbyte: Hur jobba med förändring när myndigheter slås ihop?",
      bodyText: {
        content:
          '<div><p>Den 4 okt bjuder Rörlighet i staten in till ett gemensamt, digitalt samtal kring hur vi kan jobba med förändring när myndigheter slås ihop. Vi tar vara på erfarenheter och samtalar kring framgångsfaktorer och fallgropar.</p><p>Några av Rörlighet i statens medlemmar har varit med om en sammanslagning, andra kommer kanske att slås ihop framöver och några myndigheter får nya verksamheter eller blir av med verksamheter. Många av våra myndigheter står därmed inför stora förändringar.</p><p>För att lära av varandra och samtala kring frågan bjuder Rörlighet i staten nu in till ett gemensamt, digitalt erfarenhetsutbyte kring hur vi kan jobba med förändring när myndigheter slås ihop.</p><p><strong>Agenda:</strong><br />- Välkommen och inledning, Ingela Hiltula, ordförande Rörlighet i staten<br />- Vad behöver myndigheter tänka på vid en större förändring? Åsa Krook, chef arbetsgivarutveckling, Arbetsgivarverket<br />- Erfarenheter från en nyligen genomförd sammanslagning, Peter Schierbeck, Mediemyndigheten<br />- Erfarenhetsutbyte mellan deltagare med olika teman: Kommunikation, Administrativa frågor, HR och kulturfrågor, Förändringsledning och IT<br />- Panelsamtal mellan några deltagare</p><p>Samtalet leds av Christina Frimodig, samordnare för Rörlighet i staten</p><p><strong>När: </strong>4 okt kl 9-11</p><p><strong>Hur: </strong>Via Zoom<br />Några dagar före mötet skickas länken till Zoom-mötet till alla anmälda.</p><p><strong>Anmälan: </strong><a href="https://sv-se.eu.invajo.com/event/rorlighetistaten/hurjobbamedforandringnarmyndigheterslasihoperfarenhetsutbyterorlighetistaten">Anmäl dig här</a></p><p><strong>Vad är Rörlighet i statens Popup-samtal?</strong><br />Ett digitalt erfarenhetsutbyte mellan myndigheter kring en aktuell fråga. Samtalet leds av en facilitator och inleds med en introduktion av temat, därefter ett samtal mellan deltagarna. Målgruppen är medarbetare oavsett roll inom myndigheter i Rörlighet i staten.</p></div>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-07T09:21:44",
      title:
        "Kom ihåg att anmäla dig till föreläsning: Den nya åldern eller Ålderism?",
      bodyText: {
        content:
          '<div><p>Den 18 oktober kl. 09:00-10:00 adresserar John Mellkvist från Kreab det aktuella ämnet ålderism i arbetslivet. Föreläsningen syftar till att öka medvetenheten om åldersdiskriminering och främja en inkluderande arbetsmiljö där alla åldersgrupper värderas lika.</p><p><a href="/inspirationsforelasningar-och-samtal/inspirationsforelasning2/">Läs mer</a></p></div>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-07T09:21:44",
      title: "Det här är personallån",
      bodyText: {
        content:
          '<div><p>Personallån är en möjlighet inom Rörlighet i staten (RIS). Det är ett sätt för dig att prova på att jobba på en annan myndighet, till exempel att få insyn inom ett annat område, projekt eller process än du vanligtvis jobbar med. Förutom att lära sig mer inom en viss arbetsuppgift eller område brukar den som lånats in hos en annan myndighet se det som en stor utveckling rent personligen, även om lånet uppstår utifrån verksamhetsbehov. Det är en chans för dig som individ att lära dig nya saker, få ny erfarenhet och inspiration, som du sen tar med dig tillbaka ”hem” till din ordinarie arbetsplats igen. Se gärna filmen för att få en större inblick i hur det kan vara att bli utlånad via Rörlighet i staten.</p><p><a href="/utlaanad-till-annan-myndighet/">Läs mer</a></p></div>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-10T09:20:44",
      title:
        "Tillväxtverket söker utredare/strateger till nytt förenklingsråd för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Tillväxtverket. De söker just nu en utredare/strateger för regelförening till nytt Förenklingsråd för inlån.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-14T09:20:44",
      title: "Vinnova söker jurist för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Vinnova. De söker just nu en jurist för inlån.</p><p><a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-22T09:20:44",
      title: "Dags att anmäla sig till Leda utan att vara chef",
      bodyText: {
        content:
          '<p>Leda utan att vara chef vänder sig till dig som är anställd på en myndighet inom Rörlighet i staten och som leder projekt, driver utvecklingsarbete, leder team eller arbetsgrupper, men som formellt inte har en chefsroll. Du ingår i en grupp med 20 andra deltagare och tillsammans utvecklar ni ert individuella ledarskap under sex dagar fördelat på cirka tre månader. Några av dagarna genomförs i Stockholm, i övrigt digitalt.</p><p>Läs mer om utbildningens innehåll, datum och hur du anmäler dig <a href="/program-foer-din-utveckling/leda-utan-att-vara-chef">här</a>.</p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-22T09:20:44",
      title: "Dags att anmäla sig till mentorskapsprogrammet för ledare",
      bodyText: {
        content:
          '<p>2025 presenterar Rörlighet i staten ett nytt mentorskapsprogram för ledare. Ta chansen att anmäla dig. Mentor och adept träffas regelbundet under en tidsperiod på ca 12 månader för dialog och reflektion inom området ledarskap. Vid några tillfällen träffas alla mentorer och adepter i programmet för att inspireras och reflektera tillsammans kring temat ledarskap.</p><p><a href="/program-foer-din-utveckling/mentorskapsprogram-foer-chefer/">Läs mer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-10-24T09:20:44",
      title: "Det här händer i Rörlighet i staten 2025",
      bodyText: {
        content:
          '<p>Välkommen till Rörlighet i statens aktiviteter under 2025. Om du är medarbetare i Rörlighet i statens myndigheter kan du anmäla dig till utbildningar, delta i nätverk, föreläsningar och erfarenhetsutbyte. Du kan också ha praktik eller jobba ett halvår på en annan myndighet.</p><p><a href="/om-roerlighet-i-staten">Läs mer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-11-11T09:20:44",
      title:
        "Anna Klara Lindgren från Tandvårds- och läkemedelsförmånsverket (TLV) delar med sig av sina erfarenheter av att praktisera på Naturvårdsverket",
      bodyText: {
        content:
          '<p><a href="/deltagare-i-aktiviteter-beraettar/intervju-med-anna-klara-lindgren/">Läs mer</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-11-18T08:20:44",
      title: "Erfarenhetsutbyte i nätverk",
      bodyText: {
        content:
          '<p>Det finns tolv nätverk för olika professioner inom Rörlighet i staten. Du är hjärtligt välkommen att delta! <a href="/deltagare-i-aktiviteter-beraettar/natverkstraff-for-upphandlare">Här</a> hittar du en artikel om en nätverksträff för upphandlare.</p><p>Finns det inget nätverk för dig, kan du starta ett nytt. Läs mer om Rörlighet i statens nätverk <a href="/dela-erfarenhet-i-naetverk">här.</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-12-12T08:20:44",
      title: "Dags att anmäla sig till ledarskapsutveckling för chefer",
      bodyText: {
        content:
          '<p>Arbetar du som chef och vill utveckla och stärka ditt ledarskap? Då är det här utbildningen för dig. Under tio dagar får du verktyg för hur du genom ditt ledarskap kan skapa engagemang hos dina medarbetare och hur du som chef i staten kan bidra till att göra staten till en bra arbetsgivare. Sista anmälan 31 jan 2025. Läs mer <a href="/program-foer-din-utveckling/ledarskapsutveckling-foer-chefer/">här.</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2024-12-12T09:20:44",
      title: "Spelinspektionen söker kommunikatör för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Spelinspektionen. De söker just nu en kommunikatör för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-01-16T09:20:44",
      title: "Det här händer i Rörlighet i staten 2025",
      bodyText: {
        content:
          '<p>Välkommen till Rörlighet i statens aktiviteter under 2025. Om du är medarbetare i Rörlighet i statens myndigheter kan du anmäla dig till utbildningar, delta i nätverk, föreläsningar och erfarenhetsutbyte. Du kan också ha praktik eller jobba ett halvår på en annan myndighet.</p><p>Läs mer: <a href="/om-roerlighet-i-staten/">Rörlighet i staten</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-01-22T09:20:44",
      title: "Formas söker jurist för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Formas. De söker just nu en Jurist för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-01-22T09:20:44",
      title: "Tillväxtverket söker registrator för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Tillväxtverket. De söker just nu en registrator för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-01-29T09:20:44",
      title: "Vill du bli Rörlighet i statens nya samordnare?",
      bodyText: {
        content:
          '<p>Rörlighet i staten är ett samarbete mellan 19 myndigheter. Vi tror på kraften i att dela idéer, erfarenheter och kunskap och vill kontinuerligt utveckla samarbetet. I rollen som samordnare är du motor och navet i det.</p><p><a href="/media/1501/Annonsnysamordnare20250123.pdf">Läs mer (PDF)</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-02-17T09:20:44",
      title: "Elsäkerhetsverket söker controller för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Elsäkerhetsverket. De söker just nu en controller för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-02-17T10:20:44",
      title: "Tandvårds- och läkemedelsförmånsverket söker jurist för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Tandvårds- och läkemedelsförmånsverket. De söker just nu en jurist för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-03-14T10:20:44",
      title: "Skolforskningsinstitutet söker forskare/projektledare för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Skolforskningsinstitutet. De söker just nu en forskare/projektledare för inlån.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
  {
    Nyhet: {
      createDate: "2025-04-11T10:20:44",
      title: "Vinnova söker en HR-administratör för inlån",
      bodyText: {
        content:
          '<p>Prova på att jobba på Vinnova. De söker just nu en HR-administratör.</p><p>Läs mer: <a href="/utlaanad-till-annan-myndighet/">Utlånad till annan myndighet</a></p>',
      },
      ingress: {
        content: "",
      },
    },
  },
];
